import {Stack, styled} from '@mui/material';

export const ResendTokenStack = styled(Stack)`
	${({theme}) => theme.breakpoints.down('sm')} {
		padding-bottom: 72px;
	}
`;
